import { Pane } from "evergreen-ui";
import React from "react";
import { Line } from "react-chartjs-3";

function LineChart({ options, data }) {
  return (
    <Pane
      background="white"
      borderRadius={"10px"}
      position="relative"
      paddingTop={"16px"}
      paddingLeft={"12px"}
      paddingRight={"12px"}
      paddingBottom={"12px"}
      width={"100%"}
      height={"240px"}
    >
      <Line options={options} data={data} />
    </Pane>
  );
}

export default LineChart;
